import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import global from "../../scss/dhp.scss";

let style = Object.assign({}, global);

const LaserCursor = ({ isOpen }) => {
  const cursor = useRef(null);
  const cursorFollower = useRef(null);
  const setMousePosition = e => {
    if (e.target.closest(".editor-navigation")) {
      cursor.current.classList.add("d-none");
      cursorFollower.current.classList.add("d-none");
    } else {
      let boundryDia = {
        width: document.getElementById("continiuousDocumentWrap")
          ? document.getElementById("continiuousDocumentWrap").offsetWidth - 5
          : document.getElementsByTagName("body")[0].offsetWidth - 5,
        height: document.getElementById("continiuousDocumentWrap")
          ? document.getElementById("continiuousDocumentWrap").offsetHeight - 5
          : document.getElementsByTagName("body")[0].offsetHeight - 5,
      };

      if (e.clientX > 5 && e.clientX < boundryDia.width && e.clientY > 5 && e.clientY < boundryDia.height) {
        if (document.getElementById("continiuousDocumentWrap"))
          document.getElementById("continiuousDocumentWrap").style.cursor = "none";
        else document.getElementsByTagName("body")[0].style.cursor = "none";
        cursor.current.classList.remove("d-none");
        cursorFollower.current.classList.remove("d-none");
        cursor.current.style.left = `${e.clientX}px`;
        cursor.current.style.top = `${e.clientY}px`;
        cursorFollower.current.style.left = `${e.clientX - 12}px`;
        cursorFollower.current.style.top = `${e.clientY - 12}px`;
      } else {
        cursor.current.classList.add("d-none");
        cursorFollower.current.classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    if (isOpen) document.addEventListener("mousemove", setMousePosition);
    else document.getElementsByTagName("body")[0].style.cursor = "auto";

    return () => {
      document.removeEventListener("mousemove", setMousePosition);
    };
  }, [isOpen]);

  return (
    isOpen && (
      <>
        <div className={style["cursor"]} ref={cursor}></div>
        <div className={style["cursor-follower"]} ref={cursorFollower}></div>
      </>
    )
  );
};
export default LaserCursor;

LaserCursor.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
